<template>
  <qx-card title="子卡管理">
    <section slot="titleRight">
      <qx-permpisions permpisions> </qx-permpisions>
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050201':'1005030701'">
        <ImportBtn
          title="导入油卡"
          fileUrl="/file/油卡管理导入模板.xlsx"
          :isDownloadLocalTemplate="true"
          :customPost="true"
          @sub="handleImport"
        />
      </qx-permpisions>
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050202':'1005030702'">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="oilCardManagementBO.ajax?cmd=doQuery"
          :params="fullSearchData"
          :bizName="this.$route.path.includes('gasCard')?'气卡管理数据导出':'油卡管理数据导出'"
          bizCode="exp100030"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions :permpisions="this.$route.path.includes('gasCard')?'1005050203':'1005030703'">
        <el-button type="primary" plain @click="toEdit()">新增</el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
<!--              <section slot-scope="scope">-->
<!--                <section v-if="scope.column.property === 'oilCardTypeName'">-->
<!--                  <span v-if="scope.row.oilCardType===6 && scope.row.cardTypeRemark">{{scope.row.cardTypeRemark}}</span>-->
<!--                  <span v-else>{{scope.row.oilCardTypeName}}</span>-->
<!--                </section>-->
<!--                <section v-else>{{ scope.row[scope.column.property] }}</section>-->
<!--              </section>-->
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: $route.path.includes('gasCard')?'1005050204':'1005030704',
                    showCondition: scope.row.cardType === 2,
                    name: '充值',
                    event: () => toRecharge(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050205':'1005030705',
                    showCondition: true,
                    name: '账户明细',
                    event: () => toAccountDetail(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050207':'1005030707',
                    showCondition: true,
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                  {
                    permpisions:  $route.path.includes('gasCard')?'1005050206':'1005030706',
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <LogRightDialog ref="logRightDialog" busiCode="400002" />
    <DaughterCardManageDialog
      ref="daughterCardManageDialog"
      @sub="daughterCardManageSuccess"
    />
    <RechargeDialog ref="rechargeDialog" @sub="rechargeDialogSub" />
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import LogRightDialog from 'components/logRightDialog';
import DaughterCardManageDialog from './daughterCardManageDialog';
import RechargeDialog from './rechargeDialog';
import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  oilList,
  removeParentOil,
  oilImport,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    ExportBtn,
    ImportBtn,
    LogRightDialog,
    DaughterCardManageDialog,
    RechargeDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'oilCarNum', label: '子卡卡号', fixed: true },
          { prop: 'oilCardTypeName', label: '油卡类型' },
          { prop: 'plateNumber', label: '绑定车牌' },
          { prop: 'cardBalanceStr', label: '理论余额（元）', remark: '可用于分配给订单的余额' },
          { prop: 'companyName', label: '服务商' },
          { prop: 'parentOilCarNum', label: '主卡卡号' },
          { prop: 'cardTypeName', label: '来源类型' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilList,
    toEdit (item) {
      this.$refs.daughterCardManageDialog.show(item);
    },
    toRecharge (item) {
      this.$refs.rechargeDialog.show(item);
    },
    toDetail (item) {
      if (this.$route.path.includes('gasCard')) {
        this.jump({
          label: `气卡详情-${item.oilCarNum}`,
          url: `/manage/service/gasCard/daughterCardManage/detail?id=${item.cardId}`,
          full: true,
        });
      } else {
        this.jump({
          label: `油卡详情-${item.oilCarNum}`,
          url: `/manage/service/oil/daughterCardManage/detail?id=${item.cardId}`,
          full: true,
        });
      }
    },
    toAccountDetail (item) {
      if (this.$route.path.includes('gasCard')) {
        this.jump({
          label: '子卡账户明细',
          url: `/manage/service/gasCard/daughterCardManageDetail?oilCardNum=${item.oilCarNum}`,
        });
      } else {
        this.jump({
          label: '子卡账户明细',
          url: `/manage/service/oil/daughterCardManageDetail?oilCardNum=${item.oilCarNum}`,
        });
      }
    },
    daughterCardManageSuccess () {
      this.getData();
    },
    rechargeDialogSub () {
      this.getData();
    },
    async handleImport (params) {
      const res = await oilImport(params);
      if (!res.failed) {
        this.$message.success('导入成功');
        this.getData();
      }
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.oilCarNum}】这张卡吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await removeParentOil({
          cardId: item.cardId,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getList();
        }
      }
    },
    showLog (item) {
      this.$refs.logRightDialog.show(item.cardId);
    },
  },
  created () {
    if (this.$route.path.includes('gasCard')) {
      let Index;
      this.tableData.title.forEach((item, index) => {
        if (item.label.includes('油卡')) {
          item.label = item.label.replace(/油卡/g, '气卡');
        }
        if (item.prop === 'oilCardTypeName') {
          Index = index;
        }
      });
      this.tableData.title.splice(Index + 1, 0, { prop: 'cardTypeRemark', label: '类型备注' },);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
